export type MasteryType = {
  quiz_id: string;
  title: string;
  mastered_date: string;
  total_attempts: string;
  all_score_ids: string;
  post_link: string;
  isMastered: string;
};

export type MasteryTypeResponse = {
  data: MasteryType[];
  total: number;
};

export const fetchMastery = async (path: string, token: string, type: string): Promise<MasteryTypeResponse> => {
  try {
    const response = await fetch(`${import.meta.env.VITE_BASE_URL}${path}?masterybank_grade_value=${type}`, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    });
    const data: MasteryTypeResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error;
  }
};
